import { Canvas } from 'fabric';
import { useEffect } from 'react';

export const useDeactivateCanvasObjects = (
  logoCanvas: Canvas | undefined,
  qrCodeCanvas: Canvas | undefined
) => {
  useEffect(() => {
    const deActivateCanvasObject = (e: any) => {
      if (!e.target.classList.contains('upper-canvas')) {
        if (logoCanvas) {
          logoCanvas.discardActiveObject();
          logoCanvas.renderAll();
        }
        if (qrCodeCanvas) {
          qrCodeCanvas.discardActiveObject();
          qrCodeCanvas.renderAll();
        }
      }
    };
    document.body.addEventListener('click', deActivateCanvasObject);

    return function cleanup() {
      window.removeEventListener('click', deActivateCanvasObject);
    };
  }, [logoCanvas, qrCodeCanvas]);
};
